import { CHIP_MINIMIZER_MOUNT_TYPES, MOUNT_TYPE_FEATURE } from '@common/constants';
import { ApplianceType, DrawingAppliance, ProductQty, SelectedItemMap } from '@common/models';
import { productQtyFromSelectedItems } from '@common/utils/productQtyFromSelectedItems';

import { getFeatureValueByName } from '../CutoutsSection/cutouts.utils';

/**
 * Check if the chip minimizer section should be shown
 * Any appliance in the drawing that's sink-like that either has
 *  - no mount type
 *  - mount type is one of the chip minimizer mount types
 * @param appliances
 */
export const showChipMinimizer = (appliances: DrawingAppliance[]): boolean => {
    return appliances
        .filter(
            (appliance) =>
                appliance.applianceModel?.applianceType === ApplianceType.SINK ||
                appliance.applianceModel?.applianceType === ApplianceType.SINK_LABOR
        )
        .some((appliance) => {
            const mountType = getFeatureValueByName(appliance.applianceModel.features, MOUNT_TYPE_FEATURE);
            return !mountType || CHIP_MINIMIZER_MOUNT_TYPES.some((value) => mountType.match(value));
        });
};

export const getChipMinimizersProductQty = (chipMinimizers: SelectedItemMap): ProductQty[] =>
    productQtyFromSelectedItems(chipMinimizers);
